import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { createEFPic } from '@/utils/useEFPic';
import CommonButton from '@/components/EcoCreditsDay/CommonButton';
import gtm from '@/utils/gtm';
import { signupCookie } from '@/utils/cookies/signupCookie';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');

export default function RegisterBox() {
    const { t } = useLang('ecocreditsday.registerBox');
    const { locale } = useRouter();

    return (
        <div className={styles.registerBox}>
            <div className="register-box">
                <EFPic className="logo-svg" name={['register_icon.webp', 'register_icon.png']} />
                <div className="title">{t('h5Title') || t('title')}</div>
                <div className="desc">{t('h5Desc') || t('desc')}</div>
                <div
                    className="register-btn"
                    onClick={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'ecocredits_button',
                            type: 'Register',
                            list_name: t('title'),
                            button_name: t('btn_text'),
                        });
                        signupCookie?.({
                            sector_name: t('title'),
                            entry_position: 2,
                        });
                        const redirect = ['us', 'ca'].includes(locale as string)
                            ? `https://www.ecoflow.com/${locale}/my`
                            : `https://www.ecoflow.com/${locale}/ecocredits-day`;
                        window.open(`https://www.ecoflow.com/${locale}/register?redirect=${redirect}`);
                    }}
                >
                    <CommonButton disabledAni padding="10px 30px" lineHeight="23px" borderRadius="8px" bgColor="#111">
                        <div className="register-text">{t('btn_text')}</div>
                    </CommonButton>
                </div>
                <div className="login-box">
                    {t.rich('login_text', {
                        line1: (text: string) => (
                            <span
                                className="go-login"
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'ecocredits_button',
                                        type: 'Login',
                                        list_name: t('title'),
                                        button_name: t('gtm_btn_name'),
                                    });
                                    signupCookie?.({
                                        sector_name: t('h5Title') || t('title'),
                                        entry_position: 2,
                                    });
                                    const redirect = ['us', 'ca'].includes(locale as string)
                                        ? `https://www.ecoflow.com/${locale}/my`
                                        : `https://www.ecoflow.com/${locale}/ecocredits-day`;
                                    window.open(`https://www.ecoflow.com/${locale}/login?redirect=${redirect}`);
                                }}
                            >
                                {text}
                            </span>
                        ),
                    })}
                </div>
            </div>
        </div>
    );
}
